import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  getExperts: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listExpert(limit: 999) {
            items {
              id
              featured
              firstName { current }
              lastName { current }
              patronymic { current }
              shortDescription { current }
              jobPosition { current }
              photo { url }
            }
          }
        }
      `,
    }),
    "listExpert",
  ),
})
